import * as React from 'react';
import { apiApp } from '../../../../../api/app';
import { getStringConstants } from '../../../../../config/localization';
import { PostConsentRequest } from '../../../../../types/allocareTypes';
import { SignupFormState } from './SignupForm';
import { ReactSVG } from 'react-svg';
import bloodDrop from '../Blood_droplet.svg';
import css from '../emailauth.module.css';
const defaultProfileImage = `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`;

function isNumeric(n: string) {
  return !isNaN(parseFloat(n));
}

function getNumbersStringFromPhoneString(phoneString: string): string {
  let phoneNumbers = '';
  for (let i = 0; i < phoneString.length; i++) {
    if (isNumeric(phoneString[i])) {
      phoneNumbers += phoneString[i];
    }
  }
  return phoneNumbers;
}

function comparePhones(phone1: string, phone2: string) {
  if (phone1.length < 9 || phone2.length < 9) {
    return false;
  }
  const phone1Numbers = getNumbersStringFromPhoneString(phone1);
  const phone2Numbers = getNumbersStringFromPhoneString(phone2);
  if (phone1Numbers.includes(phone2Numbers) || phone2Numbers.includes(phone1Numbers)) {
    return true;
  } else {
    return false;
  }
}

interface AllocareSignupLoadingProps {
  token: string;
  filledForm: SignupFormState;
  mapToken: string;
  mapInfo: any;
  patientId: string;
  onCompleted: () => void;
}

const strings = getStringConstants();
export default function AllocareSignupLoading(props: AllocareSignupLoadingProps) {
  React.useEffect(() => {
    allocareSetup();
  }, []);

  async function allocareSetup() {
    const initialProfileRes = await apiApp.getAcProfile(props.token, props.patientId);
    if (initialProfileRes.length == 0) {
      const postProfRes = await apiApp.postAcProfile(props.token, {
        isAllosureTestDone: false,
        patientId: props.patientId,
        isPatientProfileVisible: false,
        isTeammateParticipant: false,
        profileImageUrl: defaultProfileImage,
        profilePatientName: `${props.filledForm.firstName} ${props.filledForm.lastName}`,
        story: `About: ${props.filledForm.firstName}`,
      });
      const crProfRes = await apiApp.createPatientProfile(props.token, {
        patientId: props.patientId,
        dateOfBirth: props.filledForm.dateOfBirth,
        email: props.filledForm.email,
        firstName: props.filledForm.firstName,
        lastName: props.filledForm.lastName,
        phoneNumber: props.filledForm.phoneNumber,
        profileImageUrl: defaultProfileImage,
        story: `about ${props.filledForm.firstName}`,
      });
    }
    const profileRes = await apiApp.getAcProfile(props.token, props.patientId);

    const wpRegRes = await apiApp.registerWordpressUser(props.token, props.filledForm.email);
    const wpId = wpRegRes['wpId'];

    const updateOktaProfileRes = await apiApp.oktaUserProfileUpdate(
      props.token,
      {
        firstName: props.filledForm.firstName,
        lastName: props.filledForm.lastName,
        mobilePhone: props.filledForm.phoneNumber,
        pId: props.patientId,
        primaryPhone: props.filledForm.phoneNumber,
        secondEmail: props.filledForm.email,
        wpId: parseInt(wpId),
      },
      props.filledForm.email,
    );

    const persistFhirPatientPromise = apiApp.persistAllocareFhirPatient(props.token, {
      AlloCarePatientId: props.patientId,
      DateofBirth: props.filledForm.dateOfBirth,
      FirstName: props.filledForm.firstName,
      LastName: props.filledForm.lastName,
      PhoneNumber: props.filledForm.phoneNumber,
    });

    let prefLang = 'en';
    const splitNavigatorLang = navigator.language.split('-');
    if (splitNavigatorLang.length > 0) {
      prefLang = splitNavigatorLang[0] as 'en' | 'es';
    }
    const updateProfileLanguagePromise = apiApp.updateProfileLanguage(props.token, {
      patientId: props.patientId,
      patientPrefferedLanguage: prefLang,
    });

    const emptyConsentsPromise = apiApp.saveDetailsAndConsents(props.token, {
      consentUserInfo: [],
      isTransplantPatient: profileRes[0].isTransplantPatient,
      TransplantStatus: 3,
      patientId: profileRes[0].patientId,
      recentTransplantDate: profileRes[0].recentTransplantDate,
      sfAlloCareUserId: profileRes[0].sfAlloCareUserId,
      sfPatientId: profileRes[0].sfPatientId,
      sfPCMUserId: profileRes[0].sfPCMUserId,
      sfTransplantCenterAccountId: profileRes[0].sfTransplantCenterAccountId,
      SfUniversalPatientId: profileRes[0].sfUniversalPatientId,
      sfTransplantCenterName: '',
    });

    await Promise.all([persistFhirPatientPromise, updateProfileLanguagePromise, emptyConsentsPromise]);

    const updateTransplantStatus = await apiApp.updateProfile(props.token, {
      PatientId: props.patientId,
      DateOfBirth: props.filledForm.dateOfBirth,
      FirstName: props.filledForm.firstName,
      LastName: props.filledForm.lastName,
      IsAllosureTestDone: false,
      IsPreTransplantPatient: false,
      IsTransplantPatient: false,
      TransplantStatus: 3,
      SfPatientId: profileRes[0].sfPatientId,
      SfPCMUserId: profileRes[0].sfPCMUserId,
      SfTransplantCenterAccountId: profileRes[0].sfTransplantCenterAccountId,
      SfUniversalPatientId: profileRes[0].sfUniversalPatientId,
      SfTransplantCenterName: '',
    });

    const consentsMaster = await apiApp.getConsentMaster(props.token);

    const consentsToSave = consentsMaster
      .filter((x) => x.isConsentMandatory)
      .map<PostConsentRequest>((x) => ({
        consentId: x.consentId,
        isChecked: true,
        patientEmail: props.filledForm.email,
        patientFirstName: props.filledForm.firstName,
        patientId: props.patientId,
        patientpreferredLanguage: prefLang,
      }));
    const postConsentUserReq = await apiApp.postConsentUser(props.token, consentsToSave);
    const confirmMap = await apiApp.confirmMap(props.mapToken);
    await apiApp.manuallyLinkAllocareMap(props.token, props.mapInfo.mapid, props.patientId);
    props.onCompleted();
  }

  return (
    <div style={{ maxWidth: '441px', padding: '2em' }}>
      <ReactSVG className={css.suLoadingImage} src={bloodDrop} />
      <div className={css.suLoadingText}>{strings.SU_PLEASE_WAIT}</div>
    </div>
  );
}
